const state = {
    vehicles: [],
    vehicleId: [],
    loading: false
};

export default state;